import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useTheme } from 'app/shopify';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Pressable, View } from 'react-native';

interface HelpStepLink {
  labelKey: string;
  onPress: () => void;
}

interface HelpStepConfig {
  icon: React.ReactNode;
  titleKey: string;
  textKey: string;
  links?: HelpStepLink[];
}

export function HelpStepRow({ step }: { step: HelpStepConfig }) {
  const theme = useTheme();
  const { t } = useTranslation('help');

  return (
    <Row alignItems="flex-start" gap="spacing.general.x4">
      <View
        style={{
          width: 48,
          height: 48,
          borderRadius: 24,
          backgroundColor: theme.colors['surface.brand.secondary-5.subtle'],
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {step.icon}
      </View>
      <Column flex={1} gap="spacing.general.x1">
        <Text fontWeight="700" fontSize={16} variant="bodyBase">
          {t(step.titleKey)}
        </Text>
        <Text fontSize={15} variant="bodyBase">
          <Trans components={{ strong: <Text fontWeight="700" /> }} i18nKey={step.textKey} ns="help" />
        </Text>
        {step.links?.map((link) => (
          <Pressable key={link.labelKey} onPress={link.onPress}>
            <Text color="text.emphasized" fontWeight="700" fontSize={15}>
              {t(link.labelKey)} →
            </Text>
          </Pressable>
        ))}
      </Column>
    </Row>
  );
}
